const FormattedMoney = ({ amount }) => {
    const amountt = amount ? amount : 0;

    const formatter = new Intl.NumberFormat('fr-FR',  {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return formatter.format(amountt);
};

export default FormattedMoney;